<template>
    <div class="d-flex solicitar-telefone-wrapper">
        <div class="d-flex align-center solicitar-telefone">
            <span class="solicitar-telefone-label">{{ label }}</span>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-icon size="13px">mdi-information</v-icon>
                    </span>
                </template>
                <span>{{ informacao }}</span>
            </v-tooltip>
        </div>

        <v-switch
            class="ma-0 pa-0"
            color="primary"
            dense
            hide-details
            v-model="value.solicitarTelefoneAssinatura"
            :disabled="desabilitarCampo"
        />
    </div>

</template>

<script>
export default {
    name: 'SwitchSolicitarTelefoneAssinatura',
    props: {
        value: {
            required: true
        },
        desabilitarCampo: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        informacao: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="stylus" scoped>
.solicitar-telefone-wrapper
    justify-content space-between

    .solicitar-telefone
        gap 5px

        .solicitar-telefone-label
            color var(--text-color-300)
            font-size 16px
</style>
